// React imports.
import React from "react";

//app imports
import {Assessment3aVendorAssignedStatusEnum} from "../state";

const Assessment3aMainTableRow = ({ state, fuel, step, fieldChangeHandler, rowClass }) => (
    <React.Fragment>
        <div className={"dwGridRow col1 "+ rowClass} >{fuel.description}</div>
        <div className={"dwGridRow  col2 blue-background "+ rowClass}>
            <input id="totalAssistedhHNum" name="totalAssistedhHNum" value={fuel.totalAssistedhHNum} 
                onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                className="form-control " />
        </div>
        {step.showVendorAssignedEntry === true &&
            <div className={"dwGridRow col3 yellow-background "+ rowClass} >
                <input id="hHAssignedVendorNum" name="hHAssignedVendorNum" value={fuel.hHAssignedVendorNum} 
                  onChange={(changeEvent) => fieldChangeHandler(changeEvent, fuel)} 
                  className="form-control " />
            </div>
        }
        {step.showVendorAssignedStatus === true &&
            <React.Fragment>
                {(fuel.vendorAssignmentStatus ==Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget
                    || fuel.vendorAssignmentStatus ==Assessment3aVendorAssignedStatusEnum.EntryError)
                    &&
                    <div className={"dwGridRow col4 red-background "+ rowClass} >
                        {fuel.vendorAssignmentPercentString}
                    </div>
                }
                {(fuel.vendorAssignmentStatus ==Assessment3aVendorAssignedStatusEnum.Over95NoIssues)
                    &&
                    <div className={"dwGridRow col4 green-background "+ rowClass} >
                        {fuel.vendorAssignmentPercentString}
                    </div>
                }
                {(fuel.vendorAssignmentStatus ==Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed)
                    &&
                    <div className={"dwGridRow col4 "+ rowClass} >
                        {fuel.vendorAssignmentPercentString} 
                    </div>
                }
            </React.Fragment>
        }

        {step.showVendorAssignedStatus === true &&
            <React.Fragment>
                {(fuel.vendorAssignmentStatus ==Assessment3aVendorAssignedStatusEnum.Under95NotMeetTarget)
                    &&
                    <div className={"dwGridRow col5 red-background "+ rowClass} >
                        <strong>Issue Found - </strong> You DO NOT have an electric vendor on file for at 
                        least  95%  of your  {fuel.description}   households. 
                    </div>
                }
                {(fuel.vendorAssignmentStatus ==Assessment3aVendorAssignedStatusEnum.Over95NoIssues)
                    &&
                    <div className={"dwGridRow col5 green-background "+ rowClass} >
                        <strong>No Issue - </strong> You have an electric vendor on file for at
                        least   95%   of your  {fuel.description}   households.
                    </div>
                }
                {(fuel.vendorAssignmentStatus ==Assessment3aVendorAssignedStatusEnum.NoHouseholdsServed)
                    &&
                    <div className={"dwGridRow col5 "+ rowClass} >
                        N/A
                    </div>
                }
                {(fuel.vendorAssignmentStatus ==Assessment3aVendorAssignedStatusEnum.EntryError)
                    &&
                    <div className={"dwGridRow col5  red-background "+ rowClass} >
                        Data entry error.
                    </div>
                }
            </React.Fragment>
        } 
    </React.Fragment>
);

export default Assessment3aMainTableRow;
